export default "__VITE_ASSET__DbfCJvdt__"